export enum TripWarningCodeEnum {
    DRIVER_NOT_FOUND = 'DRIVER_NOT_FOUND',
    VEHICLE_NOT_FOUND = 'VEHICLE_NOT_FOUND',
    CARRIER_NOT_FOUND = 'CARRIER_NOT_FOUND',
    SEMITRAILER_NOT_FOUND = 'SEMITRAILER_NOT_FOUND',
    ORDER_CREATION_FAILED = 'ORDER_CREATION_FAILED',
    ORDER_DUPLICATE_CODE = 'ORDER_DUPLICATE_CODE',
}
